window.blogJS = (() => {
  if (!window.blogJS) {
    const links = document.querySelectorAll(".js-link");

    links.forEach((link) => {
      link.addEventListener("click", () => {
        window.location.href = link.href;
      });
    });

    const showMores = document.querySelectorAll(".js-show-more-blogs");

    showMores.forEach((showMore) => {
      showMore.addEventListener("click", () => {
        // Get the next sibling UL element
        const grandparent = showMore.parentElement.parentElement;

        const articlesUl = grandparent.querySelector("ul");

        // If a ul is found, select the articles within
        if (articlesUl) {
          const articles = articlesUl.querySelectorAll(".js-article");

          // Now we can perform actions on just these articles
          articles.forEach((article) => {
            article.classList.remove(
              "blog__article--mobile",
              "blog__article--desktop"
            );
          });
        }

        showMore.classList.add("hidden");
      });
    });
  }

  return true;
})();
